import { type BackendErrorEntity, BackendErrorCode } from '~/apiClient';

export default function (data: unknown): data is BackendErrorEntity {
    const { code } = (data as any)?.error ?? {};

    return code && Object.values(BackendErrorCode).some(backendErrorCode => code === backendErrorCode);
}
